// src/components/Configurator/renderers/AirConditionerExternalRenderer.jsx
import React from "react";
import {
  SELECTED_ELEMENT_COLOR,
  defaultObjectSizes,
  OBJECT_TYPES,
} from "../configuratorConstants";
import { ReactComponent as AirConditionerExternalIcon } from "../../Assets/airout.svg";

const AirConditionerExternalRenderer = ({
  element,
  scale,
  isSelected,
  wallThickness,
  placementSideFactor,
}) => {
  const defaults = defaultObjectSizes[OBJECT_TYPES.EXTERNAL_AIR_CONDITIONER];
  const elementWidthM = element.width || defaults.width;
  const elementDepthM = element.depth || defaults.depth;

  const elementWidthPx = elementWidthM * scale;
  const elementDepthPx = elementDepthM * scale;
  const wallThicknessPx = wallThickness * scale;

  // ИЗМЕНЕНО: Сдвигаем блок так, чтобы он был прижат к внешней стороне стены
  const yOffset =
    placementSideFactor * (wallThicknessPx * -0.4 + elementDepthPx / 2);

  const iconStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.2)" : "#fff",
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : "#4B5563",
    strokeWidth: isSelected ? 1.5 : 1,
  };

  const groupTransform = `translate(0, ${yOffset}) ${
    placementSideFactor === 1 ? "scale(1, -1)" : ""
  }`;

  return (
    <g transform={groupTransform}>
      <AirConditionerExternalIcon
        x={-elementDepthPx / 2}
        y={-elementWidthPx / 2}
        width={elementDepthPx}
        height={elementWidthPx}
        preserveAspectRatio="xMidYMid meet"
        style={iconStyle}
      />
    </g>
  );
};

export default React.memo(AirConditionerExternalRenderer);